import { LeadReport1 } from "./_components/lead-report-1";
import { LeadReport2 } from "./_components/lead-report-2";
import { LeadReport3 } from "./_components/lead-report-3";

const AdminLeadsReportPage = () => {
  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Lead Reports</h3>
      </div>

      <div className="mt-4 mb-10">
        <LeadReport1 />

        <LeadReport2 />

        <LeadReport3 />
      </div>
    </div>
  );
};

export default AdminLeadsReportPage;
